import type {Address} from '@/services/CompanyService'
import type {Maybe} from '@/types'

const MARKET_TRENDS_REGIONS = ['IT', 'CH']

export function isMarketTrendsVisible(address: Maybe<Address>, marketTrendsEnabled: boolean, isAdmin: boolean): boolean {
  const isInMarketTrendsRegion = MARKET_TRENDS_REGIONS.includes(address?.countryCode || '')
  if (!isInMarketTrendsRegion) {
    return false
  }

  return marketTrendsEnabled || isAdmin
}
